import { render, staticRenderFns } from "./doorcodes.vue?vue&type=template&id=522ea312"
import script from "./doorcodes.vue?vue&type=script&lang=js"
export * from "./doorcodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports